import { basePublicClient } from "@/constants/contracts";
import { CONTRACTS } from "@/constants/contracts";
import { ERC20_ABI, TOKEN_ADDRESSES } from "@/constants/token-address";
import { queryOptions } from "@tanstack/react-query";

export const getBalancesOptions = () => {
	return queryOptions({
		queryKey: ["balanceOf"],
		staleTime: 5 * 60 * 1000,
		queryFn: async () => {
			const balances: Record<
				string,
				{
					address: string;
					ETH?: bigint;
					USDC?: bigint;
					LINK?: bigint;
					CREDIT?: bigint;
				}
			> = {};

			await Promise.allSettled(
				Object.entries(CONTRACTS).map(async ([name, contract]) => {
					balances[name] = {
						address: contract.address,
					};

					const [ethBalance, usdcBalance, linkBalance, creditsBalance] =
						await Promise.all([
							basePublicClient.getBalance({
								address: contract.address as `0x${string}`,
							}),
							basePublicClient.readContract({
								address: TOKEN_ADDRESSES.USDC as `0x${string}`,
								abi: ERC20_ABI,
								functionName: "balanceOf",
								args: [contract.address as `0x${string}`],
							}),
							basePublicClient.readContract({
								address: TOKEN_ADDRESSES.LINK as `0x${string}`,
								abi: ERC20_ABI,
								functionName: "balanceOf",
								args: [contract.address as `0x${string}`],
							}),
							basePublicClient.readContract({
								address: TOKEN_ADDRESSES.CREDIT as `0x${string}`,
								abi: ERC20_ABI,
								functionName: "balanceOf",
								args: [contract.address as `0x${string}`],
							}),
						]);

					balances[name] = {
						address: contract.address,
						ETH: ethBalance,
						USDC: usdcBalance,
						LINK: linkBalance,
						CREDIT: creditsBalance,
					};
				}),
			);

			return balances;
		},
	});
};
